const siteKey = import.meta.env.VITE_RECAPTCHA_SITE_KEY;
const action =
  import.meta.env.VITE_RECAPTCHA_ACTION || "checkout_purchase";
let loadPromise;

function loadScript() {
  if (!siteKey) return Promise.resolve();
  if (window.grecaptcha?.enterprise) return Promise.resolve();
  if (loadPromise) return loadPromise;
  loadPromise = new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = `https://www.google.com/recaptcha/enterprise.js?render=${encodeURIComponent(
      siteKey
    )}`;
    script.async = true;
    script.defer = true;
    script.onload = resolve;
    script.onerror = () => reject(new Error("Falha ao carregar a verificação"));
    document.head.appendChild(script);
  });
  return loadPromise;
}

export async function executeCommerceRecaptcha() {
  if (!siteKey) return null;
  await loadScript();
  if (!window.grecaptcha?.enterprise) {
    throw new Error("Verificação de segurança indisponível");
  }
  await new Promise((resolve) => window.grecaptcha.enterprise.ready(resolve));
  return window.grecaptcha.enterprise.execute(siteKey, { action });
}
